import { appConstants, loadScript } from "@abp";
import { useEffect } from "react";

declare const abp: any;

export const useSignalR = () => {
  useEffect(() => {
    const encryptedAuthToken = abp.utils.getCookieValue(
      appConstants.authorization.encrptedAuthTokenName
    );

    if (!encryptedAuthToken) return;

    abp.signalr = {
      autoConnect: true,
      connect: undefined,
      hubs: undefined,
      qs:
        appConstants.authorization.encrptedAuthTokenName +
        "=" +
        encodeURIComponent(encryptedAuthToken),
      remoteServiceBaseUrl: appConstants.remoteServiceBaseUrl,
      url: "/signalr",
    };

    loadScript(appConstants.appBaseUrl + "/abp.signalr-client.js");

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        const connection = abp.signalr?.hubs?.common;
        if (connection?.state === "Disconnected") {
          abp.signalr.connect();
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
};
